/* Siluetopía · bloque de compra propio.
   El cliente elige cuántas historias (1 a 5) y cuáles. Por defecto se asignan
   historias distintas; puede cambiar cualquiera y repetir si quiere.
   - Pagar en línea: agrega al carrito con el código del paquete y va al checkout.
   - Pagar al recibir: agrega al carrito y abre el carrito, donde está el formulario
     contra entrega de Releasit (lee el carrito y aplica su descuento).
   El formulario de Releasit dentro de la ficha queda oculto. */
(function () {
  var NIVELES = [
    { n: 1 },
    { n: 2, tag: 'Más elegido' },
    { n: 3 },
    { n: 4 },
    { n: 5, tag: 'Colección', oro: true }
  ];
  function fmt(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); }

  function iniciar() {
    var dataEl = document.getElementById('st-bx-data');
    if (!dataEl) return true;
    var cont = document.getElementById('_rsi-form-container-embedded');
    var raiz = document.getElementById('st-bx-root');
    var ancla = raiz || document.querySelector('product-form, .product-form, .st-producto-info form[data-st-form]') || cont;
    if (!ancla) return false;
    if (document.querySelector('.st-bx')) return true;

    var data = JSON.parse(dataEl.textContent);
    var vars = data.variantes.filter(function (v) { return v.disponible; });
    if (!vars.length) {
      // La página pudo quedar guardada con inventario en cero: se consulta la disponibilidad real
      if (!dataEl.dataset.stRevisado) {
        dataEl.dataset.stRevisado = '1';
        var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || dataEl.getAttribute('data-handle');
        if (handle) fetch('/products/' + handle + '.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (p) {
          var real = {}; p.variants.forEach(function (v) { real[v.id] = v.available; });
          data.variantes.forEach(function (v) { if (real[v.id] !== undefined) v.disponible = real[v.id]; });
          dataEl.textContent = JSON.stringify(data);
          iniciar();
        }).catch(function () {});
      }
      return true;
    }
    var pct0 = data.pct || 0;
    function pe(k) { return k >= 2 ? pct0 : 0; }  /* el descuento empieza desde el 2.º libro */
    var pct = pct0;
    var simple = !!data.simple;
    var precio = vars[0].precio;
    document.documentElement.classList.add('st-bb-on');
    if (simple) document.documentElement.classList.add('st-bb-simple');

    /* ---------- Estado ---------- */
    var n = 1;
    var preferida = new URLSearchParams(location.search).get('variant');
    var base = vars.filter(function (v) { return String(v.id) === preferida; })[0] || vars[0];
    var orden = [base].concat(vars.filter(function (v) { return v !== base; }));
    var picks = [base.id];
    function ajustar() {
      if (picks.length > n) picks = picks.slice(0, n);
      while (picks.length < n) {
        var libre = orden.filter(function (v) { return picks.indexOf(v.id) < 0; })[0];
        picks.push(libre ? libre.id : base.id);
      }
    }
    function porId(id) { return vars.filter(function (v) { return v.id === id; })[0]; }

    /* ---------- UI ---------- */
    var ui = document.createElement('div');
    ui.className = 'st-bx';
    ui.innerHTML = (simple ? '' :
      '<div class="st-bx-head"><p class="st-bx-titulo">Elige tu paquete</p>' +
      '<p class="st-bx-sub">' + pct0 + '% de descuento desde tu segundo libro + caja de marionetas de la familia de regalo</p></div>' +
      '<div class="st-bx-niveles" role="radiogroup" aria-label="Cantidad de historias">' +
      NIVELES.map(function (nv) {
        var sub = precio * nv.n, fin = Math.round(sub * (100 - pe(nv.n)) / 100);
        return '<button type="button" class="st-bx-nivel" data-n="' + nv.n + '" role="radio">' +
          (nv.tag ? '<span class="st-bx-tag' + (nv.oro ? ' st-bx-tag--oro' : '') + '">' + nv.tag + '</span>' : '') +
          '<span class="st-bx-num">' + nv.n + '</span><span class="st-bx-lbl">' + (nv.n === 1 ? 'historia' : 'historias') + '</span>' +
          '<span class="st-bx-fin">' + fmt(fin) + '</span></button>';
      }).join('') + '</div>' +
      '<div class="st-bx-elige"><p class="st-bx-elige-t"><span data-elige-txt></span><b data-elige-cuenta></b></p>' +
      '<ol class="st-bx-slots" data-slots></ol></div>');

    var cta = document.createElement('div');
    cta.className = 'st-bb-cta';
    cta.innerHTML =
      '<div class="st-bb-ahorro" data-ahorro-box><span class="st-bb-ahorro-ic" aria-hidden="true">🎉</span><div class="st-bb-ahorro-t"><b data-ahorro></b><small data-ahorro-sub></small></div><span class="st-bb-ahorro-pct" data-ahorro-pct></span></div>' +
      '<div class="st-bx-res"><div><span class="st-bx-res-total" data-total></span> <s data-sub></s></div><span class="st-bx-res-lbl">Total con descuento</span></div>' +
      '<ul class="st-bb-benef">' + (data.regalo ? '<li><img src="' + (data.regaloImg || '') + '" alt=""><span><b>Caja de marionetas</b><small>De la familia, de regalo</small></span><em>Gratis</em></li>' : '') +
      '<li><i aria-hidden="true">🚚</i><span><b>Envío a toda Colombia</b><small>Llega en 2 a 4 días hábiles</small></span><em>Gratis</em></li>' +
      '<li><i aria-hidden="true">💵</i><span><b>Paga al recibir</b><small>O en línea: tarjeta, PSE, Nequi</small></span><em class="is-check">✓</em></li></ul>' +
      '<button type="button" class="st-bb-btn" data-agregar><span class="st-bb-btn-txt">Agregar al carrito</span><b class="st-bb-total"></b></button>' +
      '<p class="st-bb-nota">Paga en línea o al recibir. La dirección te la pedimos al final.</p>' +
      '<p class="st-bb-error" hidden></p>';

    if (raiz) { raiz.appendChild(ui); raiz.appendChild(cta); }
    else { ancla.parentNode.insertBefore(ui, ancla); ancla.parentNode.insertBefore(cta, ancla); }
    if (cont) cont.classList.add('st-rsi-oculto');

    function q(sel) { return ui.querySelector(sel) || cta.querySelector(sel); }

    var abierto = -1;
    function pintarSlots() {
      var ol = q('[data-slots]'); if (!ol) return;
      ol.innerHTML = picks.map(function (id, i) {
        var v = porId(id) || vars[0];
        var opciones = vars.map(function (o) {
          return '<button type="button" class="st-bx-op' + (o.id === id ? ' is-on' : '') + '" data-slot="' + i + '" data-id="' + o.id + '"><img src="' + o.cov + '" alt=""><span>' + o.titulo + '</span></button>';
        }).join('');
        return '<li class="st-bx-slot' + (abierto === i ? ' is-abierto' : '') + '">' +
          '<button type="button" class="st-bx-slot-btn" data-abrir="' + i + '"><img src="' + v.cov + '" alt=""><span class="st-bx-slot-t"><small>Historia ' + (i + 1) + '</small>' + v.titulo + '</span><span class="st-bx-slot-cambiar">Cambiar</span></button>' +
          '<div class="st-bx-ops">' + opciones + '</div></li>';
      }).join('');
    }
    function pintar() {
      ajustar();
      ui.querySelectorAll('.st-bx-nivel').forEach(function (b) {
        var on = parseInt(b.dataset.n, 10) === n;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
      });
      pct = pe(n);
      var sub = precio * n, fin = Math.round(sub * (100 - pct) / 100);
      q('[data-total]').textContent = fmt(fin);
      q('[data-sub]').textContent = pct ? fmt(sub) : '';
      q('[data-ahorro]').textContent = pct ? 'Ahorras ' + fmt(sub - fin) : '';
      var asub = q('[data-ahorro-sub]'); if (asub) asub.textContent = pct ? pct + '% de descuento en ' + (n === 1 ? 'tu libro' : 'tus ' + n + ' libros') + ' + regalo' : '';
      var apct = q('[data-ahorro-pct]'); if (apct) apct.textContent = '−' + pct + '%';
      var abox = q('[data-ahorro-box]'); if (abox) { abox.style.display = pct ? '' : 'none'; abox.classList.remove('is-pulso'); void abox.offsetWidth; abox.classList.add('is-pulso'); }
      q('.st-bb-total').textContent = fmt(fin);
      var et = q('[data-elige-txt]'); if (et) et.textContent = n === 1 ? 'Tu historia' : 'Tus ' + n + ' historias';
      var ec = q('[data-elige-cuenta]'); if (ec) ec.textContent = n > 1 ? 'Toca una para cambiarla o repetirla' : 'Toca para cambiarla';
      pintarSlots();
    }

    ui.addEventListener('click', function (e) {
      var nv = e.target.closest('.st-bx-nivel');
      if (nv) { n = parseInt(nv.dataset.n, 10); abierto = -1; pintar(); return; }
      var ab = e.target.closest('[data-abrir]');
      if (ab) { var i = parseInt(ab.dataset.abrir, 10); abierto = abierto === i ? -1 : i; pintarSlots(); return; }
      var op = e.target.closest('.st-bx-op');
      if (op) { picks[parseInt(op.dataset.slot, 10)] = parseInt(op.dataset.id, 10); abierto = -1; pintarSlots(); }
    });

    /* ---------- Carrito ---------- */
    function itemsDelPaquete() {
      var cuenta = {};
      picks.forEach(function (id) { cuenta[id] = (cuenta[id] || 0) + 1; });
      return Object.keys(cuenta).map(function (id) { return { id: parseInt(id, 10), quantity: cuenta[id] }; });
    }
    function agregar(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); });
    }
    function error(btn) {
      btn.classList.remove('is-cargando');
      var err = q('.st-bb-error'); err.textContent = 'No pudimos agregar tu pedido. Intenta de nuevo.'; err.hidden = false;
    }
    function seccionesDrawer() {
      var d = document.querySelector('cart-drawer');
      return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    }
    q('[data-agregar]').addEventListener('click', function () {
      var btn = this; btn.classList.add('is-cargando');
      q('.st-bb-error').hidden = true;
      var items = itemsDelPaquete();
      if (data.regalo) items.push({ id: data.regalo, quantity: 1, properties: { 'Regalo': '1 por pedido' } });
      var paso = data.codigo ? fetch('/discount/' + encodeURIComponent(data.codigo), { credentials: 'same-origin' }) : Promise.resolve();
      paso.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: seccionesDrawer().join(','), sections_url: window.location.pathname })
        });
      }).then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); })
        .then(function (state) {
          btn.classList.remove('is-cargando');
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.renderContents === 'function' && state.sections) {
            d.classList.remove('is-empty');
            d.renderContents(state);
          } else {
            window.location.href = '/cart';
          }
        }).catch(function () { error(btn); });
    });

    // Los botones "Comprar ahora" de Releasit en el resto de la página llevan al paquete
    document.addEventListener('click', function (e) {
      var b = e.target.closest('#rsi_buy_now_button, ._rsi-buy-now-button');
      if (b && !(cont && cont.contains(b)) && !b.closest('cart-drawer, .cart__footer')) {
        e.preventDefault(); e.stopPropagation();
        ui.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, true);

    pintar();
    return true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  function seguro() { try { return iniciar(); } catch (e) { console.error('st-buybox', e); quitarBloqueo(); return true; } }
  function quitarBloqueo() { document.documentElement.classList.remove('st-bb-on'); }
  // Si por cualquier razón el paquete no se pinta, se devuelve la compra original
  setTimeout(function () { if (!document.querySelector('.st-bx, .st-bb-cta')) quitarBloqueo(); }, 6000);
  function arrancar() {
  if (!seguro()) {
    var intentos = 0;
    var iv = setInterval(function () { if (seguro() || ++intentos > 60) clearInterval(iv); }, 250);
  }
}
})();
